import { render, staticRenderFns } from "./KorisniciTab.vue?vue&type=template&id=33ef0f29"
import script from "./KorisniciTab.vue?vue&type=script&lang=js"
export * from "./KorisniciTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports